import { Column } from './types';

export const FEEDBACK_REPORT_TITLE = 'Activeweb Feedback Report';

export const FEEDBACK_REPORT_GRID_TITLE = 'activeWebFeedbackReport';

export const FEEDBACK_REPORT_MESSAGE =
  'Provides the detail of all Feedback entries for the chosen date range';

export const columns: Column[] = [
  { name: 'activeWebID', title: 'ActiveWebID' },
  { name: 'registration', title: 'Registration' },
  { name: 'claimReference', title: 'Claim Reference' },
  { name: 'repairerName', title: 'Repairer Name' },
  { name: 'userID', title: 'User ID' },
  { name: 'feedbackDate', title: 'Feedback Date', type: 'date' },
  { name: 'feedbackType', title: 'Feedback Type' },
  { name: 'feedbackComment', title: 'Feedback Comment' },
];